//import { createState } from '@src/helpers/createState'
//import { combineReducers } from 'redux'
//import * as actionTypes from '../constants/actionTypes'
//import * as STATE from '../constants/state'
//const reducer = combineReducers({
//  [STATE.MOBILE_SETTINGS]: createState(actionTypes.MOBILE_SETTINGS),
//  [STATE.MOBILE_SETTINGS_VERSIONS]: createState(actionTypes.MOBILE_SETTINGS_VERSIONS),
//})
//export const MOBILE_SETTINGS = STATE.GLOBAL_STATE
//export default reducer
import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, MOBILE_SETTINGS, MOBILE_SETTINGS_VERSIONS } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const MOBILE_SETTING_STATE = GLOBAL_STATE

export const { reducer: mobileSettingsReducer } = createSlice({
  name: MOBILE_SETTING_STATE,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.mobileSettings.pending, state => {
        state[MOBILE_SETTINGS].loading = true
      })
      .addCase(actionCreators.mobileSettings.rejected, (state, action) => {
        state[MOBILE_SETTINGS].loading = false
        state[MOBILE_SETTINGS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.mobileSettings.fulfilled, (state, action) => {
        state[MOBILE_SETTINGS].loading = false
        state[MOBILE_SETTINGS].error = null
        state[MOBILE_SETTINGS].data = action.payload
      })

    builder
      .addCase(actionCreators.mobileSettingsVersions.pending, state => {
        state[MOBILE_SETTINGS_VERSIONS].loading = true
      })
      .addCase(actionCreators.mobileSettingsVersions.rejected, (state, action) => {
        state[MOBILE_SETTINGS_VERSIONS].loading = false
        state[MOBILE_SETTINGS_VERSIONS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.mobileSettingsVersions.fulfilled, (state, action) => {
        state[MOBILE_SETTINGS_VERSIONS].loading = false
        state[MOBILE_SETTINGS_VERSIONS].error = null
        state[MOBILE_SETTINGS_VERSIONS].data = action.payload
      })

    builder.addCase(actionCreators.mobileSettingsVersionsClear, state => {
      state[MOBILE_SETTINGS_VERSIONS] = defaultState()
    })
  },
})
